import api from "../api/client";
const options = {
  endpoint: "api/v1/ProtegoUserRole",
  baseEndpoint: "api/v1/ProtegoUserRole",
  data: {}
};
export default { 
    GetProtegoUserRoleReport(data, token) {
        options.token = token;
        options.data = data;
        options.endpoint = `${options.baseEndpoint}/List`;
        return api.list(options);
    },
    GetAllRoles(token) {
        options.token = token;
        options.endpoint = `${options.baseEndpoint}/GetAllRoles`;
        return api.get(options);
    },
    GetAllAgencies(token) {
        options.token = token;
        options.endpoint = `${options.baseEndpoint}/GetAllAgencies`;
        return api.get(options);
    },
    GetAllPermissions(token) {
        options.token = token;
        options.endpoint = `${options.baseEndpoint}/GetAllPermissions`;
        return api.get(options);
    },
    DownloadList(token, data) {
        options.token = token;
        options.data = data;
        options.endpoint = `${options.baseEndpoint}/DownloadList`;
        return api.download(options);
    },
}